module.exports = __webpack_public_path__ + "img/ZDS_15.da0d8fd2.jpg";